import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useI18n } from "@/lib/i18n";

function ItemList({ items, fields, onChange, testid, addLabel }) {
  const { t } = useI18n();
  const upd = (i, k, v) => onChange(items.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  return (
    <div className="space-y-2" data-testid={testid}>
      {items.map((x, i) => (
        <div key={x.key || i} className="flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 p-2" data-testid={`${testid}-row-${i}`}>
          {fields.map(([k, l]) => <Input key={k} placeholder={t(l)} value={x[k] || ""} onChange={(e) => upd(i, k, e.target.value)} className="h-9 flex-1 min-w-[140px]" data-testid={`${testid}-${k}-${i}`} />)}
          <Input type="number" min={0} value={x.price} onChange={(e) => upd(i, "price", e.target.value)} className="h-9 w-24" data-testid={`${testid}-price-${i}`} />
          <button type="button" onClick={() => onChange(items.filter((_, j) => j !== i))} className="p-1 text-slate-400 hover:text-red-600" data-testid={`${testid}-remove-${i}`}><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={() => onChange([...items, { key: "", name: "", name_es: "", price: 0 }])} data-testid={`${testid}-add`}><Plus className="h-4 w-4 me-1" />{t(addLabel)}</Button>
    </div>
  );
}

export function CleaningSettings({ cleaning, setCleaning }) {
  const { t } = useI18n();
  const set = (k) => (v) => setCleaning((c) => ({ ...c, [k]: v }));
  return (
    <div className="rounded-2xl bg-white border border-slate-200 p-6 lg:col-span-2 space-y-6" data-testid="setting-cleaning">
      <div><p className="font-semibold mb-1">{t("cl.owner_t")}</p><p className="text-xs text-slate-500">{t("cl.owner_d")}</p></div>
      <div><p className="text-sm font-semibold mb-2">{t("cl.packages")} (USD)</p>
        <ItemList items={cleaning.packages} onChange={set("packages")} testid="setting-pkg" addLabel="cl.add_pkg"
          fields={[["name", "cl.name_en"], ["name_es", "cl.name_es"], ["desc", "cl.desc_en"], ["desc_es", "cl.desc_es"]]} /></div>
      <div><p className="text-sm font-semibold mb-2">{t("cl.addons")} (USD)</p>
        <ItemList items={cleaning.addons} onChange={set("addons")} testid="setting-addon" addLabel="cl.add_addon" fields={[["name", "cl.name_en"], ["name_es", "cl.name_es"]]} /></div>
      <div><p className="text-sm font-semibold mb-2">{t("cl.banks_t")}</p>
        <div className="grid md:grid-cols-3 gap-4">
          {Object.keys(cleaning.banks).map((b) => (
            <label key={b} className="text-sm space-y-1"><span className="text-xs font-semibold text-slate-600">{b}</span>
              <Textarea rows={3} placeholder={t("cl.acct_ph")} value={cleaning.banks[b]} onChange={(e) => { const v = e.target.value; setCleaning((c) => ({ ...c, banks: { ...c.banks, [b]: v } })); }} data-testid={`setting-bank-${b}`} /></label>
          ))}
        </div>
      </div>
    </div>
  );
}
